import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DealData } from '../integration.dto';

export interface Deal {
    resource?: string
    view?: string
    userId?: string
    companyId?: string
    selectedIds?: string
    token?: string
}

@Injectable({
    providedIn: 'root'
})

export class PipeDriveService {

    constructor(private http: HttpClient) { }

    /**
     * add a person that is fetch via pipe drive deal id
     * @param deal_id 
     */
    addPersonOfPipeDrive(deal_id: string) {
       return this.http.post('integrations/pipedrive/deals/add/persons', {deal_id:deal_id});
    }

    /**
     * get the deal detail
     * @param deal_id 
     */
    getDealDetail(dealData: DealData){
        const params = dealData?.provider === "msdynamic" ? `entity_id=${dealData?.deal_id}&entity_name=${dealData?.entity_name}` : `deal_id=${dealData?.deal_id}&is_company=${dealData?.type === 'deal' ? 0 : 1}`
        return this.http.get(`integrations/${dealData?.provider}/deals?${params}`);
    }

}